export default __webpack_public_path__ + "static/media/musicBikram2.6d10fc6e.jpeg";